export enum FieldDisplayType {
    Text = 'Text',
    MultiSelect = 'MultiSelect',
    StaticDropdown = 'StaticDropdown',
    DateRange = 'DateRange',
    Boolean = 'Boolean',
    Bates = 'Bates',
    CustomCodingText = 'CustomCodingText',
    CustomCodingCheckbox = 'CustomCodingCheckbox',
    CustomCodingSharedCheckbox = 'CustomCodingSharedCheckbox',
    ControlNumber = 'ControlNumber',
    SearchReport = 'SearchReport'
}
